module.exports = __webpack_public_path__ + "static/media/tumor.60922263.png";